<!-- 
For refactoring
1. Use Province, City/Municipality, Barangay dropdown selectors. See AddEditBillingContact.vue for example 
 -->
<template>
    <v-form @submit.prevent="updateMember" ref="form">
        <v-card class="rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">Edit Personal Details</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{ errorMessage }}
            </v-alert> 
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 sm6 class="form-item">
                        <v-text-field label="Prefix"
                            v-model="prefix"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="form-item">
                        <v-text-field label="First Name"
                            v-model="firstName"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6 class="form-item">
                        <v-text-field label="Middle Name"
                            v-model="middleName"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="form-item">
                        <v-text-field label="Last Name"
                            v-model="lastName"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap dense>
                    <v-flex xs12 sm12 class="form-item">
                        <v-text-field label="Address (House/building No, Street, Village, Barangay)"
                            v-model="addressLine1"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm5 class="form-item">
                        <v-text-field label="City"
                            v-model="city"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm5 class="form-item">
                        <v-text-field label="Province"
                            v-model="province"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm2 class="form-item">
                        <v-text-field label="Zip Code"
                            v-model="zipCode"
                            :rules="[rules.zipCode]"
                            :disabled="disabled"
                            mask="####"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6 class="form-item">
                        <v-menu v-model="menuBirthDate" :close-on-content-click="false" :nudge-right="40"
                            lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="birthDate" label="Birth Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                            </template>
                            <v-date-picker no-title v-model="birthDate" :allowed-dates="allowedDates" @input="menuBirthDate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="form-item">
                        <v-select
                            label="Civil Status"
                            :items="civil_status"
                            :rules="[rules.required]" 
                            item-value="civilStatus"
                            item-text="statusDescription"
                            :disabled="disabled"
                            v-model="civilStatus"
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6 class="form-item">
                        <v-select
                            label="Gender"
                            :items="['Male','Female', 'Other', 'Prefer not to say']"
                            :rules="[rules.required]" 
                            :disabled="disabled"
                            v-model="gender"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 class="form-item">
                        <v-text-field label="Cellphone"
                            v-model="phone"
                            :rules="[rules.cellphone]"
                            :disabled="disabled"
                            mask="+63-###-#######"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="mr-25">
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :loading="loading" dark>Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import userApi from '@/api/user'

export default {
    name: 'dialog',
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            disabled: false,
            error: false,
            menuBirthDate: false,
            gender: null,
            country_list: [],
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                },
                cellphone: value => {
                    const pattern = /\d{2}\d{3}\d{7}/
                    return pattern.test(value) || 'Invalid Cellphone no.'
                },
                zipCode: value => {
                    const pattern = /\d{4}/
                    return pattern.test(value) || 'Invalid Zip Code'
                },
            },
            civil_status: [
                {civilStatus: 38, statusDescription: 'Single'},
                {civilStatus: 39, statusDescription: 'Married'},
                {civilStatus: 40, statusDescription: 'Widowed'},
                {civilStatus: 41, statusDescription: 'Divorced'},
                {civilStatus: 42, statusDescription: 'Separated'},
                {civilStatus: 43, statusDescription: 'Annulled'},
            ],
            basic_info: null,
            address_info: null,
            userId: null,
            prefix: null,
            firstName: null,
            middleName: null,
            lastName: null,
            phone: null,
            gender: null,
            civilStatus: null,
            birthDate: null,
            position: null,
            addressLine1: null,
            zipCode: null,
            city: null,
            province: null,
        }
    },
    methods: {
        async setParamsEdit(basic_info, address_info){
            this.basic_info = basic_info
            this.address_info = address_info
            this.birthDate = this.basic_info.birthDate ? this.$moment(this.basic_info.birthDate).format('YYYY-MM-DD') : null
            this.userId = this.basic_info.userId
            this.prefix = this.basic_info.prefix
            this.firstName = this.basic_info.firstName
            this.middleName = this.basic_info.middleName
            this.lastName = this.basic_info.lastName
            this.phone = this.basic_info.phone
            this.gender = this.basic_info.gender
            this.civilStatus = this.basic_info.civilStatus
            this.position = this.basic_info.position
            this.addressLine1 = this.address_info.addressLine1
            this.zipCode = this.address_info.zipCode
            this.city = this.address_info.city
            this.province = this.address_info.province
        },
        closeDialog() {
           this.$emit('update:dialogUpdate', false)
        },
        async updateMember() {
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true

                    var data = {
                        userId: this.userId,
                        prefix: this.prefix,
                        firstName: this.firstName,
                        middleName: this.middleName,
                        lastName: this.lastName,
                        phone: this.phone,
                        gender: this.gender,
                        civilStatus: this.civilStatus,
                        birthDate: this.$moment(this.birthDate).format('YYYY-MM-DD'),
                        position: this.position,
                        addressLine1: this.addressLine1,
                        zipCode: this.zipCode,
                        city: this.city,
                        province: this.province,
                        countryId: 169 // original design of table was to support different countries
                    }

                    const response = await userApi.updateMyPesonalDetails(data)

                    if (response && response.status == 200) {
                        this.loading = false
                        this.disabled = false
                        this.clearForm()
                        this.$emit('send', 'Edit')
                        this.closeDialog()
                    }
                }catch(error) {
                    this.errorMessage = error
                    this.error = true
                }
            }
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
        allowedDates(val) {
            return this.$moment(Date()).format('YYYY-MM-DD') > this.$moment(val).format('YYYY-MM-DD')
        }
    },
    computed: {},
    created() {}
  }
</script>
<style scoped>
.form-item {
    padding: 0px 20px 0px 20px;
}
</style>